import type { MouseEvent } from 'react';

import { useAppSelector } from '@app/store/store';
import { useModal } from '@contexts/modal-context/ModalContext';
import { getUserPermissions } from '@features/user-management/utils/user-management.utils';
import { MODAL_KEYS } from '@shared/components/ui/custom/global-modal-manager/global-manager.types';

import type { User } from '../api/user-management.types';

export const useUserRowActions = (rowData: User) => {
  const {
    username: currentUsername,
    user: { roles: loggedInUserRoles },
  } = useAppSelector((state) => state.authentication);

  const { openModal } = useModal();

  const { canEdit, canDeleteOrLock, canResetPassword } = getUserPermissions(
    loggedInUserRoles,
    rowData.roles,
    currentUsername ?? '',
    rowData.email,
  );

  const handleLockUnlockUserClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    //TODO: open corresponding  modal when implemented    //TODO: open corresponding  modal when implemented
  };

  const handleResetUserPasswordClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    //TODO: open corresponding  modal when implemented
  };

  const handleDeleteUserClick = () => {
    openModal(MODAL_KEYS.DELETE_USER, { rowData });
  };

  const handleEditUserClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    //TODO: open corresponding  modal when implemented
  };

  return {
    canEdit,
    canDeleteOrLock,
    canResetPassword,
    handleLockUnlockUserClick,
    handleResetUserPasswordClick,
    handleDeleteUserClick,
    handleEditUserClick,
  };
};
